<template>
  <div class="banner">
    <img :src="bannerPic" alt="" style="width:100%">
    <div class="banner-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {downloadAttachFile} from "@/utils/indexUrl";
import {Base64} from "js-base64";
export default {
  data() {
    return {
      bannerPic: '',
      bannerHeight: ''
    };
  },
  props: {
    outBannerHeight: { // banner高度
      type: String
    },
    bannerAttachPath: { // banner附件地址
      type: String
    },
    defaultBanner: { // 默认banner图
      type: String
    }
  },
  watch: {
    bannerAttachPath: {
      handler() {
        this._downloadAttachFile()
      },
      immediate: true
    }
  },
  methods: {
    getBannerHeight() {
      let clientWidth = document.documentElement.clientWidth > 1200 ? document.documentElement.clientWidth : 1200
      this.bannerHeight = clientWidth / 1920 * parseInt(this.outBannerHeight) + 'px'
    },
    _downloadAttachFile() {
      if (!this.bannerAttachPath) {
        return false
      }
      downloadAttachFile({
        openOnline: true,
        stream: true,
        attachPath: this.bannerAttachPath
      }, null, {
        responseType: 'arraybuffer'
      }).then(res => {
        if (!res.byteLength) {
          return false
        }
        if (res.byteLength == 15 && decodeURIComponent(escape(String.fromCharCode.apply(null, new Uint8Array(res)))) == '文件不存在') {
          return false
        }
        let type = this.bannerAttachPath.split('.')[1]
        let typeHeader = `data:image/${type};base64,` // 定义base64 头部文件类型
        this.bannerPic = typeHeader + Base64.btoa(new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), ''));  // 拼接最终的base64
      }).catch(err => {
        console.log(err)
      })
    },
  },
  created() {
    // 处理banner图片
    this.bannerPic = this.defaultBanner

  },
  mounted() {
    // 处理banner图片高度
    // this.bannerHeight = this.outBannerHeight
    // this.getBannerHeight()
    // window.addEventListener('resize', this.getBannerHeight)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.getBannerHeight)
  }
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  .banner-content{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 50%;
    margin-left: -600px;
  }
}
</style>
